import React, { useState, useEffect } from 'react'
import { Panel, Button, Input, ControlLabel, Checkbox, Message } from 'rsuite'
import { useParams, useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { updateChangeAgreement } from '../../redux/actions/contract'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import pathname from '../../constants/pathname'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'

export default function PetitionMoreRequest(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit, isDirectorMoreRequest } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isApproveError, setIsApproveError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [note, setNote] = useState()
  const [isCriticalImpacted, setIsCriticalImpacted] = useState(false)

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsApproveError('')
    let request = {
      projectVersionId: projectId,
      userId: '',
      value: note,
      isCriticalImpacted: isDirectorMoreRequest
        ? schema.isCriticalImpacted.value
        : isCriticalImpacted,
    }

    console.log('request', JSON.stringify(request))

    try {
      let response
      if (isDirectorMoreRequest) {
        response = await updateChangeAgreement(request, projectId)
      } else {
        response = await updateChangeAgreement(request, projectId)
      }

      console.log('response', response)
      if (isDirectorMoreRequest) {
        if (response.success && response?.model?.isSuccess) {
          setShowConfirm(false)
          setIsApproveError('')
          doneLoading()
          setIsLoading(false)
          sessionStorage.setItem('projectId', response.model.projectVersionId)
          sessionStorage.setItem('param', '')

          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        } else {
          setShowConfirm(false)
          setIsApproveError(response.message || response.errorMessage)
        }
      } else {
        if (response.success) {
          setIsLoading(false)
          doneLoading()
          setShowConfirm(false)
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      }
    } catch (e) {
      console.log('e', e)
      setIsError(
        e?.response?.data?.errors?.Message ||
          e?.response?.data?.errorMessage ||
          schema.buttonText + `ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`
      )
    }
    setIsLoading(false)
    doneLoading()
    setShowConfirm(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    setNote(data.note)
    setIsCriticalImpacted(data.IsCriticalImpacted)
    setShowConfirm(true)

    // handleCallService(request)
  }

  return (
    <div>
      <Panel header={schema.header} collapsible defaultExpanded bordered shaded>
        {schema?.isCriticalImpacted && schema.isCriticalImpacted.readonly ? (
          schema.isCriticalImpacted.value && (
            <Message showIcon type="warning" description={schema.isCriticalImpacted.label} />
          )
        ) : (
          <Controller
            key={schema.isCriticalImpacted.name}
            name={schema.isCriticalImpacted.name}
            control={control}
            defaultValue={schema.isCriticalImpacted.value}
            render={(props) => {
              return (
                <Checkbox
                  name={schema.isCriticalImpacted.name}
                  value={schema.isCriticalImpacted.value}
                  onChange={(value, checked) => setValue(schema.isCriticalImpacted.name, checked)}
                  disabled={schema.isCriticalImpacted.disabled}
                >
                  {schema.isCriticalImpacted.label}
                </Checkbox>
              )
            }}
          />
        )}
        <br />

        {schema?.approveComments?.length > 0 &&
          schema?.approveComments?.map((item, index) => {
            return (
              <Message
                key={index}
                type={'info'}
                description={`${item.label || 'ไม่ระบุ'} : ${item.value || 'ไม่ระบุ'}`}
              />
            )
          })}

        {schema?.note && (
          <>
            <ControlLabel>{requiredFiled(schema.note.validators, schema.note.label)}</ControlLabel>
            <ErrorMessage error={errors[schema.note.name]} />
            <br />
            <Input
              name={schema.note.name}
              inputRef={register(isValidators(schema.note.validators))}
              rows={3}
              placeholder={schema.note.hint}
              componentClass="textarea"
            />
            <hr />

            {isError && <Message showIcon type="error" description={isError} />}
            {isApproveError && <Message showIcon type="error" description={isApproveError} />}

            {isDirectorMoreRequest && (
              <Button style={{ width: 250 }} appearance="ghost" onClick={handleSubmit(onSubmit)}>
                {schema.buttonText}
              </Button>
            )}

            {!isDirectorMoreRequest && (
              <ApproverList
                approveType={6}
                projectversionId={projectId}
                style={{ marginLeft: 10 }}
                buttontext={'ตรวจสอบสายอนุมัติและ' + schema.buttonText}
                isLoading={isLoading}
                fetchButton={(disabled) =>
                  <Button
                    style={{ width: 250, marginBottom: 10}}
                    appearance="ghost"
                    onClick={handleSubmit(onSubmit)}
                    disabled={disabled}
                  >
                    {schema.buttonText}
                  </Button>
                }
              />
            )}
          </>
        )}
      </Panel>
      <br />

      <ConfirmWidget
        size={'sm'}
        title={`ยืนยันการ${schema.buttonText}`}
        show={showConfirm}
        detail={`กรุณายืนยันการ${schema.buttonText}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      />
    </div>
  )
}
